import { Link, post, useState, MyIcon, useNavigate, useEffect, MsgCaptcha, get, Func, config } from '@/common';
import { Form, Input, Button } from 'antd';
import {
    IdcardOutlined,
    MobileOutlined,
    KeyOutlined,
    SafetyOutlined
} from '@ant-design/icons';
import '@/assets/style/entrance.scss';
import Copyright from '@/components/Copyright';
import Funcs from '@/Func'
// import { useParams } from 'react-router-dom';

function Main(props: any) {
    const [form] = Form.useForm();
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const [type, setLoginType] = useState('password');
    const [configs, setConfigs] = useState(Funcs.getConfigs());

    const onFinish = (data: any) => {
        setLoading(true)
        data['type'] = type
        post('/system/member/login', data).then(data => {
            if (data.code) return
            data = data.data
            localStorage.setItem('member', JSON.stringify(data.member))
            localStorage.setItem('module', JSON.stringify(data.module))
            // localStorage.setItem('config', JSON.stringify(data.config))
            window.location.href = '/'
        }).finally(() => {
            setLoading(false)
        })
    }
    useEffect(() => {
        get('/system/config').then(data => {
            setConfigs(data.data)
        })
        // 已登录跳转
        if (localStorage.getItem('member')) {
            navigate('/')
        }
    }, [])
    return (
        <div className="entrance" style={configs.system && configs.system.login_bg && { backgroundImage: `url(${Func.getRealUrl(configs.system.login_bg)})` }}>
            <Form
                className="form"
                onFinish={onFinish}
                form={form}
            >
                <img className="logo" src={(configs.system && configs.system.logo && Func.getRealUrl(configs.system.logo)) || "/images/logo.png"} alt="LOGO" />
                <div className="name">{(configs.system && configs.system.name) || config.name}</div>
                {
                    type === 'password' &&
                    <>
                        <Form.Item
                            name="account"
                            rules={[{ required: true, message: '账号/手机号必填' }]}
                        >
                            <Input allowClear size="large" placeholder="请输入账号/手机号" prefix={<IdcardOutlined />} />
                        </Form.Item>
                        <Form.Item
                            name="password"
                            rules={[{ required: true, message: '密码必填' }]}
                        >
                            <Input.Password allowClear size="large" placeholder="请输入密码" prefix={<KeyOutlined />} />
                        </Form.Item>
                    </>
                }
                {
                    type === 'phone' &&
                    <>
                        <Form.Item
                            name="phone"
                            rules={[{ required: true, message: '手机号必填' }]}
                        >
                            <Input allowClear size="large" placeholder="请输入手机号" prefix={<MobileOutlined />} />
                        </Form.Item>
                        <Form.Item
                            className="captcha"
                        >
                            <Form.Item
                                noStyle
                                name="captcha"
                                rules={[{ required: true, message: '验证码必填' }]}
                            >
                                <Input allowClear size="large" placeholder="请输入验证码" maxLength={4} prefix={<SafetyOutlined />} />
                            </Form.Item>
                            <MsgCaptcha form={form} type="login" />
                        </Form.Item>
                    </>

                }
                <Button size="large" type="primary" htmlType="submit" block loading={loading}>
                    登录
                </Button>
                <div className="register">
                    {/* <Link to="/register">立即注册</Link> */}
                    <div></div>
                    {/* <Link to="/find_pw">忘记密码？</Link> */}
                </div>
                <div className="line">
                    <div></div>
                    <span>其它登录方式</span>
                    <div></div>
                </div>
                <div className="other">
                    {
                        type === 'password' ?
                            <MyIcon className="phone" type="icon-shoujihao" title="手机号登录" onClick={() => { setLoginType('phone') }} /> :
                            <MyIcon className="phone" type="icon-mima" title="密码登录" onClick={() => { setLoginType('password') }} />

                    }
                    {/* <MyIcon className="wx" type="icon-weixin" title="微信号登录" /> */}
                </div>
            </Form>
            <Copyright />
        </div>
    )
}

export default Main